import {RoleService} from '@services/role.service';
import {Component, Renderer2} from '@angular/core';
import {
    NavigationCancel,
    NavigationEnd,
    NavigationError,
    NavigationStart,
    Router
} from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    isLoading = false; // Loader flag to control visibility

    constructor(
        private router: Router,
        private renderer: Renderer2,
        private roleService: RoleService
    ) {}

    ngOnInit(): void {
        // Subscribe to router events to control loader visibility
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.isLoading = true; // Show the loader when navigation starts
            } else if (
                event instanceof NavigationEnd ||
                event instanceof NavigationCancel ||
                event instanceof NavigationError
            ) {
                // Once route has finished loading, listen for window load event
                const windowLoadListener = this.renderer.listen(
                    'window',
                    'load',
                    () => {
                        this.isLoading = false; // Hide the loader after window finishes loading assets
                        windowLoadListener(); // Remove event listener after it's triggered
                    }
                );

                // Add a fallback timer to ensure the loader hides even if `window.load` doesn't trigger
                setTimeout(() => {
                    this.isLoading = false;
                    windowLoadListener(); // Remove event listener after the timeout as well
                }, 1500); // Fallback after 5 seconds
            }
        });
        const userDetailStr = localStorage.getItem('UserDetail');
        const userDetail = userDetailStr ? JSON.parse(userDetailStr) : null;
        const savedRole = userDetail?.role?.roleName;
        if (savedRole) {
            this.roleService.setRole(savedRole);
        }
    }
}
